import React, {useEffect, useRef} from "react";
import {isEmpty} from "lodash";
import {Scrollbars} from "react-custom-scrollbars-2";
import {useDispatch, useSelector} from "react-redux";
import {Navigate, Routes, Route, useLocation} from "react-router-dom";
import ConfirmationModal from "../components/Modal/ConfirmationModal";
import AppNavbar from "../components/Navbars/AppNavbar";
import BackButton from "../components/Navbars/components/Back";
import Sidebar from "../components/Sidebar/Sidebar";
import {ProfileContext} from "../contexts/profileContext.js";
import {requestUserProfile} from "../redux/Actions/users.action";
import {getThemeName} from "../redux/Selectors/theme.selectors.js";
import {getUserProfile} from "../redux/Selectors/users.selector.js";
import {appRoutes} from "../routes.js";
import CookieService from "../service/cookieService";
import "../default.scss";
import "./App.scss";

const AppLayout = () => {
  const dispatch = useDispatch();
  const mainContentRef = useRef();
  const userProfile = useSelector(getUserProfile);
  const themeName = useSelector(getThemeName);
  const location = useLocation();
  const currentPath = location.pathname.split("/")[2];

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
    if (isEmpty(userProfile)) {
      dispatch(requestUserProfile());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRoutes = () => {
    return appRoutes.map((route, index) => {
      const {path, component: Component} = route;
      return (
        <Route
          path={path}
          element={
            CookieService().isTokenAvailable() ? (
              <Component />
            ) : (
              <Navigate to="/auth/login" replace />
            )
          }
          key={index}
        />
      );
    });
  };

  return (
    <ProfileContext.Provider value={userProfile}>
      <div data-theme={themeName}>
        <Sidebar />
        <AppNavbar
          brandText={
            currentPath === "organizationAddress" ? "organization address" : currentPath
          }
        />
        <Scrollbars
          style={{width: "100%", height: "calc(100vh - 20px)"}}
          autoHide={false}
          renderTrackVertical={({style, ...props}) => (
            <div
              {...props}
              style={{
                ...style,
                backgroundColor: "var(--slider-runnable-track)",
                borderRadius: "8px",
                width: "12px",
                position: "absolute",
                right: "2px",
                bottom: "2px",
                top: "120px",
              }}
            />
          )}
          renderThumbVertical={({style, ...props}) => (
            <div
              {...props}
              style={{
                ...style,
                backgroundColor: "var(--slider-thumb-color)",
                borderRadius: "8px",
              }}
            />
          )}
        >
          <div className="main-content" ref={mainContentRef}>
            {!(currentPath === "home") && (
              <div className="back-btn-wrapper">
                <BackButton />
              </div>
            )}
            <Routes>
              {getRoutes()}
              <Route path="/" replace element={<Navigate to="home" />} />
              <Route path="*" replace element={<Navigate to="home" />} />
            </Routes>
          </div>
        </Scrollbars>
        <ConfirmationModal />
      </div>
    </ProfileContext.Provider>
  );
};

export default AppLayout;
